import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";

const UserPrivateRoute = () => {
  const { auth, loading } = useAuth();
  const location = useLocation();

  // console.log(`🔍 Checking UserPrivateRoute for: ${location.pathname}`);
  // console.log(`👤 User Authenticated: ${auth.isAuthenticated}`);
  // console.log(`⏳ Loading state: ${loading}`);

  if (loading) {
    //console.log("⏳ Waiting for authentication to finish...");
    return null; // ✅ Prevent early redirect while checking session
  }

  if (!auth.isAuthenticated) {
    console.log(`🚨 Not authenticated! Redirecting to /login`);
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  //console.log(`✅ Access Granted to ${location.pathname}`);
  return <Outlet />;
};

export default UserPrivateRoute;
